import axios from 'axios';
import { useEffect, useRef } from 'react';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { net_api_url } from 'components/Store';
import { useAuth0 } from '@auth0/auth0-react';
import useGetAccessToken from './useGetAccessToken';
import JSONBigInt from 'json-bigint';
const node_api_url = `${import.meta.env.VITE_APP_NODEAPIURL}`;

const useGeneralApiCall = () => {
  const { isAuthenticated } = useAuth0();

  const cancelSource = useRef(null);
  const { getAccessToken } = useGetAccessToken();

  useEffect(() => {
    const source = new AbortController();
    cancelSource.current = source;
    return () => {
      source.abort('General api call cancelled by the user');
    };
  }, []);

  const generalApiCall = async (props) => {
    const {
      method,
      pathname,
      requestProperties,
      notShowErrorMessage,
      returnCompleteRequest,
      needsAuthentication,
      requestSource,
      requestHeaders: propsRequestHeaders,
      bigInt,
      returnError,
      returnCancelled,
      nodeAPI,
      responseType,
    } = props;
    try {
      let token = isAuthenticated ? await getAccessToken() : '';
      let localRequestHeaders = {
        signal: requestSource?.signal ?? cancelSource?.current?.signal,
      };
      if (needsAuthentication) {
        localRequestHeaders = {
          ...localRequestHeaders,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }
      if (bigInt) {
        localRequestHeaders = {
          ...localRequestHeaders,
          transformResponse: [(data) => data],
        };
      }
      if (responseType) {
        localRequestHeaders = {
          ...localRequestHeaders,
          responseType,
        };
      }
      let requestHeaders = propsRequestHeaders ?? localRequestHeaders;

      let request;
      if (method === 'delete' && requestProperties) {
        request = await axios.delete(`${nodeAPI ? node_api_url : net_api_url}${pathname}`, {
          ...requestHeaders,
          data: requestProperties,
        });
      } else {
        const propertiesConditional = method === 'post';
        request = await axios[method](
          `${nodeAPI ? node_api_url : net_api_url}${pathname}`,
          propertiesConditional ? requestProperties : requestHeaders,
          propertiesConditional ? requestHeaders : ''
        );
      }

      return returnCompleteRequest ? request : bigInt ? JSONBigInt.parse(request.data) : request.data;
    } catch (error) {
      if (error.name === 'CanceledError') {
        console.error(error?.config?.signal?.reason);
      } else {
        console.error(error);
      }

      if (error?.response && returnError) {
        return error.response;
      } else if (!error?.response && returnCancelled) {
        return error;
      }
      let message = `An error ocurred.`;
      if (typeof error?.response?.data === 'string' && !!error?.response?.data) {
        message = error?.response?.data;
      }
      if (!!error?.response?.data?.message) {
        message = error.response.data.message;
      }
      if (!notShowErrorMessage) {
        createNotification('danger', message);
      }
    }
  };
  return { generalApiCall };
};

export default useGeneralApiCall;
